import { Navigate, Outlet } from 'react-router-dom';

import { useEntitlements } from '@/hooks/api/useEntitlements';
import { useWorkspaceStore } from '@/hooks/state';
import { PageLoader } from '@knitknot/shared/components/ui/page-loader';

export function FactLedgerBetaRoute() {
  const { workspaceId } = useWorkspaceStore();
  const { factLedgerBetaEnabled, isLoading } = useEntitlements(workspaceId);

  if (isLoading) return <PageLoader />;
  if (!workspaceId || !factLedgerBetaEnabled) return <Navigate to="/home" replace />;
  return <Outlet />;
}
